import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { QUOTE_STEPS } from '@shared/components/routeGuard/workflow.model';
import { WorkflowService } from '@shared/components/routeGuard/workflow.service';
import { NavigationService } from '@login/services/navigation.service';

@Component({
  selector: 'app-password-warning',
  templateUrl: './password-warning.component.html',
  styleUrls: ['./password-warning.component.scss'],
})
export class PasswordWarningComponent implements OnInit {
  constructor(
    public workflowService: WorkflowService,
    private router: Router,
    private navigationService: NavigationService,
  ) {}

  ngOnInit() {}

  changePwdCheck() {
    this.workflowService.validateSteps([
      QUOTE_STEPS.loginStartPage,
      QUOTE_STEPS.loginAuthentication,
      QUOTE_STEPS.loginAuthenticationSetup,
      QUOTE_STEPS.loginSelectDestination,
      QUOTE_STEPS.loginPasswordWarning,
    ]);
    this.router.navigate(['/login/change-password'], {
      queryParamsHandling: 'preserve',
    });
  }

  ignorePwdCheck() {
    this.navigationService.goToHomepage();
  }
}
